/**
 * @module Coach
 */

import {getField, updateField} from 'vuex-map-fields';

export default {
    namespaced: true,
    state: {
        searchText: '',
        myErrors: [],
        userList: [],
        operationList: [],
        operationData: [],
        id: 0,
        showModal: false,
        activeUsers: [],
        count7: 0,
        countLifeTime: 0,
        annualCount: 0,
        monthCount: 0,
        unusedMap: 0,
        formData: {},
        mailMsg: '',
        userId: 0,
        userInAssistance: [],
        packListData: [],
        activationListData: null,
    },
    getters: {
        getField,
    },
    mutations: {
        updateField,
        settingData: function (state, data) {
            eval("state." + data.name + "=  data.content");
        }
    },
    actions: {

        assignMember: function (state) {
            axios.get('/api/v1/searchUser/assign/' + state.state.operationData.user_id)
                .then(function () {
                    return window.location.href = '/custom/' + state.state.operationData.my_operations.risorsa_id + '/' + state.state.operationData.operazione_id;
                })
                .catch(function (error) {
                    state.commit('settingData', {content: error.response.data.errors, name: 'myErrors'});
                })
        },
        searchUser: function (state) {
            axios.get('/api/v1/searchUser/?q=' + state.state.searchText)
                .then(function (response) {
                    state.commit('settingData', {content: response.data.data, name: 'userList'});
                })
                .catch(function (error) {
                    state.commit('settingData', {content: error.response.data.errors, name: 'myErrors'});
                })
        },

        closeModal: function (state) {
            state.state.showModal = !state.state.showModal;
        },

        usersList: function (state) {
            axios.get('/api/v1/coach/userList')
                .then(response => {
                    state.commit('settingData', {content: response.data.userList, name: 'activeUsers'});
                    state.commit('settingData', {content: response.data.count7, name: 'count7'});
                    state.commit('settingData', {content: response.data.countLifeTime, name: 'countLifeTime'});
                    state.commit('settingData', {content: response.data.annualCount, name: 'annualCount'});
                    state.commit('settingData', {content: response.data.monthCount, name: 'monthCount'});
                    state.commit('settingData', {content: response.data.unusedMap, name: 'unusedMap'});
                })
        },

        openModal: function (state) {
            axios.get('/api/v1/searchUser/' + state.state.id + '/operations')
                .then(function (response) {
                    state.commit('settingData', {content: response.data, name: 'operationList'});
                    state.state.showModal = !state.state.showModal;
                })
                .catch(function (error) {
                    state.commit('settingData', {content: error.response.data.errors, name: 'myErrors'});
                })

        },

        activationList(state)
        {
          axios.get('/api/v1/coach/activationList')
              .then(response =>{
                  state.commit('settingData', {content: response.data, name: 'activationListData'});
              })
        },
        sendEmail: function(state)
        {
            axios.post('/api/v1/coach/sendEmail', state.state.formData)
                .then(response =>{
                    state.commit('settingData', {content: 'ok', name: 'mailMsg'});
                    state.commit('settingData', {content: '', name: 'formData.email'});
                })
        },



        activeAssistance: function(state)
        {
            axios.post('/api/v1/coach/activeAssistance', {
                userId: state.state.userId
            })
                .then(response =>{
                    state.dispatch('realTimeAssistance');
                })
        },

        realTimeAssistance: function(state)
        {
            axios.get('/api/v1/coach/realTimeAssistance')
                .then(response =>{
                    state.commit('settingData', {content: response.data, name: 'userInAssistance'});
                })
        },

        removeAssistance: function(state)
        {
            axios.get('/api/v1/coach/removeAssistance')
                .then(response =>{
                    state.dispatch('realTimeAssistance');
                })
        },

        packList: function(state)
        {
            axios.get('/api/v1/coach/packList')
                .then(response =>{
                    state.commit('settingData', {content: response.data, name: 'packListData'});
                })
        }


    }
}
